import React, { useMemo } from 'react';
import styles from './index.module.scss';
import { useAllOffers } from '../../api/api.calls';
import { get } from 'lodash';
import CustomImg from '../CustomImg';
import { useNavigateRoute } from '../../hooks/custom.hooks';
import defaultBrandLogo from '../../assets/global/Fallbackimage.svg';

function CategoryRow() {
  const { data: apiResponse } = useAllOffers();
  const { category } = useMemo(
    () => get(apiResponse, 'filters', {}),
    [apiResponse],
  );

  const style =
    category?.length > 4
      ? {
          display: 'grid',
          gridTemplateColumns: `repeat(${Math.ceil(category?.length / 2)}, 1fr)`,
          gridTemplateRows: 'repeat(2, 1fr)',
        }
      : {
          display: 'flex',
          gap: '16px',
          paddingLeft: '5px',
          flexWrap: 'wrap',
        };

  const navigateRoute = useNavigateRoute();

  return (
    <>
      {category?.length > 0 && (
        <div className={styles.categoryRow}>
          <div className={styles.headerRow}>
            <div className={styles.sectionName}>SHOP BY CATAGORIES</div>
            <div className={styles.underline}></div>
          </div>
          <div className={styles.dataScrollRow} style={style}>
            {category?.map((category, index) => {
              return (
                <div
                  key={index}
                  className={styles.categoryItem}
                  onClick={() =>
                    navigateRoute({
                      nextPage: `/offers/?category=${category?.id}`,
                    })
                  }
                >
                  <CustomImg
                    loading="lazy"
                    src={category.logo}
                    fallbackSrc={defaultBrandLogo}
                    alt={category.merchant_name}
                    className={styles.categoryLogo}
                  />
                  <div className={styles.categoryName}>{category.name}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(CategoryRow);
